function setChartTitle(
	chartOptions,
	text,
	textAlign = "center",
	fontSize = "16px",
	fontColor = "black",
	fontWeight = "bold"
) {
	chartOptions = {
		...chartOptions,
		title: {
			text: text,
			align: textAlign,
			style: {
				fontSize: fontSize, // Set the desired font size
				fontWeight: fontWeight, // Optional: set the font weight
				color: fontColor // Optional: set the font color
			}
		}
	};
	return chartOptions;
}

function setChartPadding(
	chartOptions,
	top = 0.0,
	right = 0.0,
	bottom = 0.0,
	left = 0.0
) {
	chartOptions = {
		...chartOptions,
		grid: {
			padding: {
				top: top,
				right: right,
				bottom: bottom,
				left: left
			} // ... other options
		}
	};
	return chartOptions;
}

function setChartLegend(
	chartOptions,
	position = "right",
	horizontalAlign = "center",
	fontSize = "14px"
) {
	chartOptions = {
		...chartOptions,
		legend: {
			show: true, // This enables the legend
			position: position, // You can choose the position of the legend
			horizontalAlign: horizontalAlign, // You can also choose the horizontal alignment
			fontSize: fontSize, // Adjust the font size of the legend text
			floating: true,
			showForSingleSeries: true
			// Additional customization options can be added here
		}
	};
	return chartOptions;
}

function setSeriesMarkers(
	chartOptions,
	shape = "circle",
	size = 6,
	strokeWidth = 1,
	strokeColor = "black",
	hoverSize = 10
) {
	chartOptions = {
		...chartOptions,
		markers: {
			shape, // Set the shape of the markers (dots)
			size: size, // Set the size of the markers (dots)
			strokeWidth: strokeWidth, // Set the width of the stroke around the marker
			strokeColors: strokeColor, // Set the width of the stroke around the marker
			hover: {
				size: hoverSize // Set the size of the marker when hovering
			}
		}
	};
	return chartOptions;
}

function estimateYAxisLimits(parameterMinValue, parameterMaxValue, minCanBeNegative = true, minMustBeZero = false) {
	if (parameterMinValue > parameterMaxValue) {
		const temp = parameterMaxValue;
		parameterMaxValue = parameterMinValue;
		parameterMinValue = temp;
	} else if (parameterMinValue == parameterMaxValue) {
		if (parameterMinValue > 0.0) {
			parameterMaxValue = 1.5 * parameterMinValue;
			parameterMinValue = 0.5 * parameterMinValue;
		} else if (parameterMaxValue < 0) {
			parameterMinValue = 1.5 * parameterMaxValue;
			parameterMaxValue = 0.5 * parameterMaxValue;
		} else {
			return { min: -1.0, max: 1.0 };
		}
	}

	const parameterRange = parameterMaxValue - parameterMinValue;
	let rangeToView = 3 * parameterRange;

	const rangeMiddle = parameterMinValue + parameterRange / 2.0;
	let middleToView = rangeMiddle; // Math.max( rangeMiddle, rangeToView/2.0); // don't let min be less than zero;

	//rangeToView = Math.min( rangeMiddle, 2 * middleToView )

	let maxValue = middleToView + 0.5 * rangeToView;
	let minValue = middleToView - 0.5 * rangeToView;
	
	if (minMustBeZero) {
		const prev_minValue = minValue;
		minValue = 0.000001;
		maxValue = maxValue - 0.5 * (minValue - prev_minValue);	
	}

	if (!minCanBeNegative) {
		const prev_minValue = minValue;
		minValue = Math.max(0.000001, minValue);
		maxValue = maxValue - 0.5 * (minValue - prev_minValue);
	}

	// return{ min: minValue as number, max: maxValue as number };
	return roundYAxisLimits(minValue, maxValue);
}

function roundYAxisLimits(min, max) {
	const num_steps = 10;
	let range_old = max - min;

	// the new step must be sufficiently rounded, depending on the size of the old step
	let scale = Math.pow(10, Math.floor(Math.log10(range_old)) - 1);
	let newMin = Math.floor(min / scale) * scale;

	range_old = max - newMin;
	const step_old = range_old / num_steps;
	var step_new = Math.round(step_old / scale) * scale;

	let newMax = newMin + step_new * num_steps;

	return { min: newMin + 0.000000001, max: newMax };
}

function setXAxisLimits(chartOptions, min_x, max_x) {
	chartOptions = {
		...chartOptions,
		xaxis: {
			...chartOptions.xaxis,
			min: min_x,
			max: max_x
		}
	};
	return chartOptions;
}

function setYAxisLimits(chartOptions, min_y, max_y) {
	chartOptions = {
		...chartOptions,
		yaxis: {
			...chartOptions.yaxis,
			min: min_y ? min_y : undefined,
			max: max_y ? max_y : undefined
		}
	};
	return chartOptions;
}

function setXAxisTitle(
	chartOptions,
	text,
	fontSize = "14px",
	fontColor = "black",
	fontWeight = "bold"
) {
	chartOptions = {
		...chartOptions,
		xaxis: {
			...(chartOptions.xaxis ? chartOptions.xaxis : {}), // in case other settings we already given
			title: {
				text: text,
				style: {
					fontSize: fontSize, // Set the desired font size
					fontWeight: fontWeight, // Optional: set the font weight
					color: fontColor // Optional: set the font color
				}
			}
		}
	};
	return chartOptions;
}

function setYAxisTitle(
	chartOptions,
	text,
	fontSize = "14px",
	fontColor = "black",
	fontWeight = "bold"
) {
	chartOptions = {
		...chartOptions,
		yaxis: {
			...(chartOptions.yaxis ? chartOptions.yaxis : {}), // in case other settings we already given
			title: {
				text: text,
				style: {
					fontSize: fontSize, // Set the desired font size
					fontWeight: fontWeight, // Optional: set the font weight
					color: fontColor // Optional: set the font color
				}
			}
		}
	};
	return chartOptions;
}

function addXAxisLine(
	chartOptions,
	x,
	label = "",
	position = "top",
	fontSize = "12px",
	lineColor = "black",
	offsetX = 0,
	offsetY = 0
) {
	const newAnnotation = {
		x: x,
		borderColor: lineColor,
		borderWidth: 3,
		label: {
			text: label,
			style: {
				color: lineColor,
				fontSize: fontSize
			},
			position: position,
			offsetX: offsetX,
			offsetY: offsetY
		}
	};

	chartOptions = {
		...chartOptions,
		annotations: {
			...chartOptions.annotations,
			xaxis: [...(chartOptions.annotations?.xaxis || []), newAnnotation]
		}
	};

	return chartOptions;
}

function addVertLine(
	chartOptions,
	x,
	y1,
	y2,
	label = "",
	position = "top",
	fontSize = "12px",
	lineColor = "black",
	offsetX = 0,
	offsetY = 0
) {
	if (!chartOptions.annotations) {
		chartOptions.annotations = {
			yaxis: [],
			xaxis: []
		};
	}

	if (x !== null) {
		// Create the vertical line annotation
		const vertLineAnnotation = {
			x: x,
			y1: y1,
			y2: y2,
			strokeDashArray: 0,
			borderColor: lineColor,
			offsetX: offsetX,
			offsetY: offsetY,
			label: {
				borderColor: lineColor,
				style: {
					color: "#fff",
					background: lineColor,
					fontSize: fontSize
				},
				text: label,
				position: position
			}
		};

		if (y1 !== null && y2 !== null) {
			// const yaxisAnnotation = {
			// 	x: x,
			// 	y1: y1,
			// 	y2: y2,
			// 	strokeDashArray: 0,
			// 	borderColor: lineColor,
			// 	offsetX: offsetX,
			// 	offsetY: offsetY
			// };
			chartOptions.annotations?.xaxis?.push(vertLineAnnotation);
		} else {
			chartOptions.annotations?.xaxis?.push(vertLineAnnotation);
		}
	}

	return chartOptions;
}

function addYAxisLine(
	chartOptions,
	y,
	label = "",
	position = "right",
	fontSize = "12px",
	lineColor = "black",
	borderColor = "black",
	offsetX = 0,
	offsetY = 0
) {
	const newAnnotation = {
		y: y,
		borderColor: lineColor,
		borderWidth: 3,
		strokeDashArray: 0,
		label: {
			borderWidth: 3,
			hideOverlappingLabels: true,
			borderColor: borderColor,
			text: label,
			style: {
				color: "black",
				background: "white",
				fontSize: fontSize
			},
			position: position,
			offsetX: offsetX,
			offsetY: offsetY
		}
	};

	chartOptions = {
		...chartOptions,
		annotations: {
			...chartOptions.annotations,
			yaxis: [...(chartOptions.annotations?.yaxis || []), newAnnotation]
		}
	};

	return chartOptions;
}

function addYAxisArea(
	chartOptions,
	y1,
	y2,
	borderColor = "rgba(0, 0, 0, 0.1)",
	fillColor = "rgba(0, 0, 0, 0.1)"
) {
	const newAnnotation = {
		y: y1,
		y2: y2,
		borderColor: borderColor,
		fillColor: fillColor,
		label: {
			text: ""
		}
	};

	chartOptions = {
		...chartOptions,
		annotations: {
			...chartOptions.annotations,
			yaxis: [...(chartOptions.annotations?.yaxis || []), newAnnotation]
		}
	};

	return chartOptions;
}

const ChartUtils = {
	setChartTitle,
	setChartPadding,
	setChartLegend,
	setSeriesMarkers,
	setXAxisLimits,
	setYAxisLimits,
	estimateYAxisLimits,
	setXAxisTitle,
	addXAxisLine,
	addVertLine,
	setYAxisTitle,
	addYAxisLine,
	addYAxisArea
};

export default ChartUtils;
